(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfClickOutside', [
    '$document', function($document) {
      return {
        restrict: 'A',
        link: function(scope, ele, attrs) {
          ele.bind('click', (function(_this) {
            return function(e) {
              return e.stopPropagation();
            };
          })(this));
          return $document.bind('click', (function(_this) {
            return function(e) {
              if (((scope.isOpen != null) && scope.isOpen) || (scope.isOpen == null)) {
                if (!(angular.element(e.target).is('input') || angular.element(e.target).is('label'))) {
                  return scope.$apply(attrs.mfClickOutside);
                }
              }
            };
          })(this));
        }
      };
    }
  ]);

}).call(this);
